import React, { useEffect, useMemo, useState } from 'react';
import { useTable, usePagination, useRowSelect } from 'react-table';
import ReactPaginate from 'react-paginate';
import '../assets/css/Table.css';
import prev from '../assets/icons/Vector 2.svg'

const Table = ({ data, columns, selectedOrgDetails, handlePageChange, pageCounts, currentPage }) => {


  const [selectedRow, setSelectedRow] = useState(null);

  useEffect(() => {
    if (selectedOrgDetails?.id) {
      setSelectedRow(selectedOrgDetails.id);
    }
  }, [selectedOrgDetails]);
  useEffect(() => {
    if (selectedOrgDetails?.user_id) {
      setSelectedRow(selectedOrgDetails.user_id);
    }
  }, [selectedOrgDetails]);

  // const selectedrow = null;
  const toggleRow = (rowId) => {

    setSelectedRow(selectedRow === rowId ? rowId : rowId);
  };


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageIndex,
    pageSize,
    gotoPage,
    pageOptions,
    nextPage,
    previousPage,
    setPageSize,

  } = useTable(
    {
      columns,
      data,
      initialState: {
        pageIndex: 0,
        pageSize: 10,
      },

    },
    usePagination,
    useRowSelect, //  Required for row selection to work!
  );



  const pageCount = Math.ceil(rows.length / 10);

  useEffect(() => {
    setSelectedRow(data[0]?.id || null)

  }, [])

  return (
    <div className="table-container">
      <div className="table-body-wrapper">
        <table {...getTableProps()} className="student-table">
          <thead>
            {headerGroups?.map(headerGroup => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers?.map(column => (
                  <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page?.map(row => {
              prepareRow(row);

              return (
                <tr {...row.getRowProps()}
                  onClick={() => {
                    toggleRow(row.original.id)
                      ; row.original.handleRowClick(row.original.id, row)
                  }
                  } // Toggle active state on click
                  className={selectedRow === row.original.id ? 'active-row' : ''}>
                  {row?.cells.map(cell => {
                    return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>;
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {/* Pagination */}
      <div className="pagination-container">

        <ReactPaginate
          previousLabel={<img src={prev} />}
          nextLabel={<svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.5 1L5.5 6L0.5 11" stroke="#7F56DA" stroke-linecap="round" />
          </svg>}
          breakLabel={"..."}
          pageCount={pageCounts ? pageCounts : pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          forcePage={Number.isInteger(currentPage) ? currentPage : 0} // ✅ SAFE
          onPageChange={pageCounts ? handlePageChange : (selectedPage) => gotoPage(selectedPage.selected)}
          // onPageChange={handlePageChange?handlePageChange:(selectedPage) => gotoPage(selectedPage.selected)}
          containerClassName={'pagination'}
          activeClassName={'active'}
          disabledClassName={'disabled'}
          pageClassName={'page-item'}
          pageLinkClassName={'page-link'}

          previousClassName={'page-item'}
          nextClassName={'page-item'}
        />

      </div>
    </div>
  );
};

export default Table;
